import type { ProfilePopoverItem } from './HeaderProfilePopover.types';

export const getExcludedShoppingListLinkId = (
    isSmartShoppingListEnabled: boolean,
): 'shoppingList' | 'smartShoppingList' =>
    isSmartShoppingListEnabled ? 'shoppingList' : 'smartShoppingList';

export const filterProfilePopoverLinksBySmartShoppingListFlag = (
    links: readonly ProfilePopoverItem[],
    isSmartShoppingListEnabled: boolean,
): ProfilePopoverItem[] => {
    const excludeId = getExcludedShoppingListLinkId(isSmartShoppingListEnabled);
    return links.filter((item) => item.id !== excludeId);
};
